import {FC, useEffect, useState} from "react";
import {Tabs, Tab, Table, Card, TableLabel, TableText, Icon} from "../../UI";
import './style-display-duration.scss';
import {useDisplayDurationExam} from '../../../hooks'

const DisplayDuration: FC = () => {

    const displayDurationExam = useDisplayDurationExam()
    const [categories, setCategories] = useState<string[]>([]);
    const [examData, setExamData] = useState<Record<string, any[]>>({});
    const [loading, setLoading] = useState(true);

    const columns = [
        {
            Header: 'Tipo de examen',
            accessor: 'type_exam',
            headerClassName: 'column-type_exam',
            width: '33%',
        },
        {
            Header: 'Visualización en Mi Portal INDISA',
            accessor: 'display',
            headerClassName: 'column-display',
            width: '33%',
        },
        {
            Header: 'Días hábiles para retiro',
            accessor: 'duration',
            headerClassName: 'column-duration',
            width: '33%',
        },
    ];

    const transformData = (data: any[]) => {

        const categoriesSet = new Set<string>();
        const examData: Record<string, any[]> = {};

        data.forEach((exam, index) => {
            const categoryName = exam.display_duration_exam_categories.category_name;

            categoriesSet.add(categoryName);

            if (!examData[categoryName]) {
                examData[categoryName] = [];
            }

            examData[categoryName].push({
                id: index + 1,
                type_exam: exam.name_exam,
                display: exam.day_withdrawal_portal,
                duration: exam.day_withdrawal
            });
        });

        const categories = Array.from(categoriesSet);

        return { categories, examData };
    };

    useEffect(() => {
        if (displayDurationExam.data && Array.isArray(displayDurationExam.data.displayDurationExam)) {
            const data = displayDurationExam.data.displayDurationExam;
            const { categories, examData } = transformData(data);
            setCategories(categories);
            setExamData(examData);
            setLoading(false);
        } else {
            console.error("Datos no válidos:", displayDurationExam.data);
        }
    }, [displayDurationExam.data]);

    return (
        <div className="display_duration p-40">
            <h2 className="fw-700 fz-20">Plazos de visualización de exámenes</h2>

            {loading ? (
                <div className="loader">Cargando...</div>
            ) : (
                <Tabs className="custom-tabs">
                    {categories.map((category) => (
                        <Tab key={category} name={category}>
                            <div className="d-none lg:d-block">
                                <Table
                                    columns={columns}
                                    data={examData[category]}
                                />
                            </div>
                            <div className="d-block lg:d-none">
                                {examData[category].map((exam: any, i: number) =>
                                    <Card key={i} className={`py-20 px-25 ${i > 0 ? 'mt-20' : ''}`}>
                                        <div>
                                            <TableLabel>Tipo de examen</TableLabel>
                                            <TableText>{exam.type_exam}</TableText>
                                        </div>

                                        <div className="mt-10">
                                            <TableLabel>Visualización en Mi Portal INDISA</TableLabel>
                                            <TableText>{exam.display}</TableText>
                                        </div>

                                        <div className="mt-10">
                                            <TableLabel>Días hábiles para retiro</TableLabel>
                                            <TableText>{exam.duration}</TableText>
                                        </div>
                                    </Card>
                                )}
                            </div>

                        </Tab>
                    ))}
                </Tabs>
            )}
        </div>
    );
};

export {DisplayDuration};
